import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonFunctions } from '../static/common-functions';

export class DispatchPartsRequestedBus extends BaseBus
{
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.addedDate = DateFunctions.getDate(this.addedDate);
        this.mobileAuthDate = DateFunctions.getDate(this.mobileAuthDate);
        this.usedPartChngDt = DateFunctions.getDate(this.usedPartChngDt);
        this.sageDt = DateFunctions.getDate(this.sageDt);

    }
    CID(): any {
        return this.dispatchPartsRequestId;
    }

    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }
    setBeforeSave() {
        let dNow = DateFunctions.getDateNow();
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = dNow;
        }
        if (!CommonFunctions.hasValue(this.updateDt)) {
            this.updateDt = dNow;
        }

        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        this.addedDate = DateFunctions.getDateTimeWithUTCOffset(this.addedDate);
        this.mobileAuthDate = DateFunctions.getDateTimeWithUTCOffset(this.mobileAuthDate);
        this.usedPartChngDt = DateFunctions.getDateTimeWithUTCOffset(this.usedPartChngDt);
        this.sageDt = DateFunctions.getDateTimeWithUTCOffset(this.sageDt);
    }
    dispatchPartsRequestId: any;
    dispatchId: any;
    personId: any;
    inventoryId: any;
    quantity: number;
    addedDate: Date;
    inventoryLocationId: any;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    qtyToXfer: number;
    isXfered: boolean;
    isWrongPart: boolean;
    viewedInMobile: boolean;
    mobileAuthDate: Date;
    mobileAuthUserId: any;
    needsReplacement: boolean;
    usedPartQuantity: number;
    fromInventoryLocationId: any;
    onConstDraw: boolean;
    currentCost: number;
    avgCost: number;
    sageDt: Date;
    usedPartChngId: any;
    usedPartChngDt: Date;
    addToOrder: boolean;
}
